import React, { createContext, useReducer, useEffect, useContext } from "react";
import { isMobile, withOrientationChange } from "react-device-detect";
import { Dimension } from "../TypesAndConstants/types";
const smallScreenTreshold = 1000
interface SizingState {
  isSmallScreen: boolean;
  screenWidth: number;
  screenHeight: number;
  isPortrait: boolean;
  isMobile: boolean;
}



export const getWindowDimensions = (): Dimension => {
  return {
    width:
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth,
    height:
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight,
  };
};

const getOrientation = (): boolean => {
  return window.matchMedia("(orientation: portrait)")? true: false;
}

let isPortrait = getOrientation();
let screenSize = getWindowDimensions();
const initState: SizingState = {
  isSmallScreen: isMobile,
  screenWidth: screenSize.width,
  screenHeight:screenSize.height,
  isPortrait,
  isMobile: isMobile
};

type topMenuActions = "set_sizes" | "set_orientation" ;

export type dispatchSizeAction = {
  type: topMenuActions;
  value: any;
};

export const SizeContext = createContext<{
  state: SizingState;
  dispatch: (action: dispatchSizeAction) => void;
}>({
  state: initState,
  dispatch: () => {},
});


const menuReducer = (
  state: SizingState = initState,
  action: dispatchSizeAction
) => {
  switch (action.type) {
    case "set_sizes":
      return { ...state, 
        screenWidth: action.value.screenWidth, 
        screenHeight: action.value.screenHeight,
        isSmallScreen: action.value.isSmallScreen,
      };
    case "set_orientation":
      return { ...state, 
        isPortrait: action.value.isPortrait
      };
    default:
      return state;
  }
};




const _SizingProvider = ({isPortrait, canvasSizeData, children }: any) => {
  const [state, dispatch] = useReducer(menuReducer, initState);

  const updateSizing = () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    const { width, height } = getWindowDimensions();
    const isSmallScreen = ( Math.min( width, height ) <= smallScreenTreshold );
    dispatch({
        type: "set_sizes",
        value: {
          screenWidth: width,
          screenHeight: height,
          isSmallScreen,
        },
      });
  }
  const updateOrientation = ( _isPortrait: boolean ) => {
    dispatch({
        type: "set_orientation",
        value: {
          isPortrait: _isPortrait,
        },
      });
  }

  /* eslint react-hooks/exhaustive-deps: off */
  useEffect(()=> {
    let _isPortrait = ( state.isMobile && state.screenWidth < state.screenHeight　)
    updateOrientation(　_isPortrait );
  }, [isPortrait, state.screenWidth] );

  useEffect(() => {
    let timeoutId: any = null;
    const resizeListener = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => updateSizing(), 150);
    };
    window.addEventListener("resize", resizeListener);

    return () => {
      window.removeEventListener("resize", resizeListener);
    };
  }, []);
  return (
    <SizeContext.Provider value={{ state, dispatch }}>
      {children}
    </SizeContext.Provider>
  );
};

export const SizingProvider = withOrientationChange(_SizingProvider) 

export const useSizingContext = () => {
  return useContext( SizeContext );
}
